// import React from 'react'

// const InlinepaperOilfilters = () => {
//   return (
//     <div>
//         <h1>Inline paper Oil filters</h1>
//     </div>
//   )
// }

// export default InlinepaperOilfilters


import React from "react";
import { Link } from "react-router-dom";
import InlinepaperOilfiltersStore from "../../Components/InlinepaperOilfiltersStore/InlinepaperOilfilterStore";
import { IoIosArrowForward } from "react-icons/io";

const InlinepaperOilfilters = () => {
  return (
    <div>
      <div className="bg_banner_about ">
        <h1>Inline Paper Oil Filters</h1>
        <div className="bread_craum">
          <Link
            to="/"
            style={{
              textDecoration: "auto",
              fontFamily: "Nunito",
              color: "#0F172B",
            }}
          >
            Home
          </Link>
          <IoIosArrowForward style={{ color: "#0F172B", marginTop: "4px" }} />
          <Link
            to="/"
            style={{
              textDecoration: "auto",
              fontFamily: "Nunito",
              color: "#0F172B",
            }}
          >
            Inline Paper Oilfilters
          </Link>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <h2
              style={{
                borderColor: "orange",
                width: "fit-content",
                borderLeftStyle: "solid",
                backgroundColor: "#474065",
                padding: "5px",
                color: "white",
                marginTop: "14px",
                marginBottom: "36px",
              }}
            >
              Inline Paper Oil Filter
            </h2>
             <InlinepaperOilfiltersStore/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InlinepaperOilfilters;
